export const header = {
  nav_home: "Accueil",
  nav_about: "À propos",
  nav_services: "Services",
  nav_partnership: "Partenariat",
  nav_contact: "Contact",
  logo_tagline: "linking people & business",
};

export const brand = {
  tagline_linking: "Linking People & Business",
  tagline_excellence: "Driving to excellence with excellent drivers …",
};

export const hero = {
  slide1_title: "Nouveaux marchés, nouvelles affaires ... aucun risque !",
  slide2_title: "Avec nous, en plein cœur de l'Europe !",
  slide3_title: "L'Allemagne (DACH) – Votre réussite avec un partenaire local !",
  slide4_title: "Plus forts ensemble !",
  slide4_subtitle: "Développement commercial\nConseil\nManagement de transition\nFormation et coaching",
  slide5_title: "Lancez-vous !",
  prev_slide: "Diapositive précédente",
  next_slide: "Diapositive suivante",
  slide_label: "Diapositive {{number}}",
};

export const intro = {
  title: "NetBasis International - linking people & business",
  paragraph1:
    "Construire, augmenter et/ou développer des affaires sur de nouveaux marchés doit être prometteur, rapide, efficace, économique et sûr pour les entreprises étrangères. Des investigations longues, un développement stratégique compliqué avec des processus de décision peu clairs, et/ou l'absence d'accès direct à ces nouveaux marchés, pour ne citer que quelques exemples, ne sont pas la bonne approche. De plus, certains fabricants souhaitent parfois essayer de pénétrer un nouveau marché sans investissements majeurs.",
  paragraph2:
    "Toutes ces réflexions et considérations mènent à {{strong}} comme le bon partenaire pour vous, car depuis plus de douze ans, nous accompagnons et soutenons des entreprises étrangères du secteur des télécommunications et de l'informatique sur de nouveaux marchés attractifs mais aussi exigeants (principalement la région DACH).",
  strong_name: "NetBasis International",
};

export const services = {
  service1_title: "Développement commercial",
  service1_description:
    "Souhaitez-vous développer votre activité réussie sur vos marchés domestiques vers de nouveaux lieux de commerce, ou cherchez-vous un soutien pour des projets déjà commencés sur de nouveaux marchés?",
  service2_title: "Conseil",
  service2_description:
    "Souhaitez-vous des conseils dans divers domaines thématiques pour l'entrée sur de nouveaux marchés, afin d'assurer le succès de votre projet d'entreprise, ou de ne pas le compromettre?",
  service3_title: "Management de transition",
  service3_description:
    "Avez-vous besoin très rapidement et dans un délai court d'une aide compétente et limitée dans le temps pour l'accomplissement de certaines tâches et/ou pour combler un manque de personnel?",
  service4_title: "Formation et coaching",
  service4_description:
    "Souhaitez-vous vous préparer de manière optimale aux conditions des nouveaux marchés, aux constellations individuelles ainsi qu'aux exigences réglementaires et aux différences culturelles?",
  read_more: "En savoir plus",
};

export const about = {
  title: "NetBasis International - drive to excellence with excellent drivers !",
  paragraph1:
    "En tant qu'experts reconnus, basés en Allemagne, le marché européen le plus important, nous de {{strong}} vous aidons à identifier les éventuelles barrières à l'entrée, à examiner diverses options stratégiques, à développer des concepts marketing réalistes, à trouver des partenaires stratégiques appropriés et/ou à approcher des clients potentiels. Concentrés sur votre succès, nous offrons une large gamme de services, notamment la planification de l'entrée sur le marché et du développement, les ventes, le marketing, les relations publiques, le support technique et, si vous le souhaitez, aussi le recrutement.",
  paragraph2:
    "Lorsque vous travaillez avec nous, vous avez d'abord un point de contact central pour l'ensemble du projet et, de plus, un accès immédiat à tout le savoir-faire et l'expertise nécessaires qui sont indispensables à votre succès. Avec notre approche pragmatique et orientée résultats, nous vous aidons à élaborer les conditions et exigences de vos pays cibles.",
  paragraph3:
    "Et vous avez le choix : Nous pouvons prendre en charge et accomplir des tâches locales individuelles ou toutes les tâches de votre entreprise, et pouvons faire le travail réel ou l'emploi complet à votre place pour une période fixe ou indéfinie. Ou nous vous soutenons d'une manière purement consultative, en tant que consultants purs, à votre propre façon. Ou vous pouvez coopérer avec nous pour la formation et le coaching.",
  paragraph4:
    "Quoi que vous choisissiez parmi nos services, {{strong}} vous aidera à coordonner tous les moyens et mesures pertinents.",
  strong_name: "NetBasis International",
};

export const experience = {
  title: "Expérience & Parcours",
  subtitle: "Plus de 12 ans d'entrée réussie sur le marché et de développement commercial dans la région DACH",
  stat1_value: "12+",
  stat1_label: "Années d'activité",
  stat2_value: "50+",
  stat2_label: "Projets réalisés",
  stat3_value: "30+",
  stat3_label: "Clients internationaux",
  stat4_value: "4",
  stat4_label: "Services principaux",
  intro:
    "Depuis sa création, NetBasis International est le pont de confiance pour les fabricants étrangers de TIC entrant sur les marchés germanophones. Notre parcours parle de lui-même — nous avons prouvé à maintes reprises qu'avec le bon partenaire local, l'entrée sur le marché devient prévisible, efficace et réussie.",
  timeline1_year: "2012",
  timeline1_title: "Fondation & premiers projets",
  timeline1_desc: "Création de NetBasis International avec la vision de connecter des entreprises TIC innovantes du monde entier avec le marché DACH. Premiers projets réussis d'entrée sur le marché pour des fabricants asiatiques et nord-américains.",
  timeline2_year: "2015",
  timeline2_title: "Élargissement du portefeuille de services",
  timeline2_desc: "Élargissement de notre offre pour inclure des services de conseil complets, la gestion intérimaire et des programmes de formation. Constitution d'un réseau de partenaires de confiance en Allemagne, en Autriche et en Suisse.",
  timeline3_year: "2018",
  timeline3_title: "Reconnaissance internationale",
  timeline3_desc: "Reconnu comme un partenaire de premier plan pour l'entrée sur le marché DACH. Soutien à des clients de plus de 15 pays sur quatre continents pour établir et développer leur présence européenne.",
  timeline4_year: "2022",
  timeline4_title: "Croissance stratégique & nouveaux marchés",
  timeline4_desc: "Approfondissement de l'expertise dans les télécommunications, l'infrastructure informatique et les solutions numériques. Élargissement des services de conseil pour couvrir la conformité réglementaire, l'adaptation culturelle et les stratégies de positionnement à long terme.",
  timeline5_year: "2026",
  timeline5_title: "Votre partenaire pour demain",
  timeline5_desc: "Évolution continue avec le paysage changeant du marché. Aujourd'hui, nous offrons une gamme complète de services qui aide les entreprises étrangères à entrer dans la région DACH en toute confiance — aucun risque, seulement des résultats.",
};

export const contact = {
  title: "Contactez-nous directement maintenant.",
  cta_button: "Formulaire de contact",
};

export const footer = {
  privacy: "Politique de confidentialité",
  contact: "Contact",
  imprint: "Mentions légales",
  copyright: "Copyright © {{year}} NetBasis International. Tous droits réservés.",
};

export const pages = {
  about_title: "À propos",
  about_subtitle: "Plus de 12 ans d'expérience en entrée sur le marché – découvrez l'équipe et les réalisations derrière NetBasis International",
  about_cta: "Prêt pour votre entrée sur le marché?",
  about_cta_button: "Contactez-nous maintenant",
  about_footer_claim: "NetBasis International - drive to excellence with excellent drivers !",
  experience_title: "Expérience",
  contact_title: "Contact",
  privacy_title: "Politique de confidentialité",
  imprint_title: "Mentions légales",
  placeholder: "Cette page sera bientôt remplie de contenu. Nous y travaillons!",
};

export const aboutHero = {
  title_line1: "Nous faisons bouger ",
  title_line2: "les choses ...",
  subtitle: "... pour VOUS !",
  heroAlt: "Un doigt touche un point numérique lumineux pour la mise en réseau TIC sur le marché DACH.",
};

export const aboutPage = {
  introTitle: "NetBasis International - linking people & business",
  p1: "NetBasis International a été fondé au début de l'année 2008 à Düsseldorf. Depuis lors, nous offrons aux fabricants étrangers des secteurs des télécommunications et/ou de l'informatique, qui souhaitent étendre leur activité commerciale sur les marchés DACH ou intensifier leurs activités existantes, sous la devise « linking people & business », toute forme de conseil et de support commercial ainsi que d'aide au développement ou à l'adaptation de produits spécifiques au marché.",
  p2: "Ensemble avec nos partenaires fabricants, nous répondons à toutes les questions et travaillons pour eux autour d'une seule préoccupation : le succès et les meilleurs résultats commerciaux sur de nouveaux marchés !",
  p3: "Pour atteindre cet objectif, les entreprises étrangères obtiennent avec nous un accès immédiat à des connaissances sectorielles, à une expérience de longue date et à des contacts étendus, elles évitent grâce à nous des barrières culturelles et/ou linguistiques avec une présence immédiate, et elles reçoivent de notre part un travail rapide sur le(s) marché(s), le(s) produit(s), les partenaires et les clients.",
  p4: "Pour renforcer les relations existantes ainsi que pour acquérir de nouveaux clients et ainsi pour un développement plus durable de nouveaux marchés, une approche partenariale dans tous les domaines de la vente et du marketing ainsi que le travail commun sur des produits et solutions exigeants et adaptés aux exigences du marché (matériel et logiciel) sont nécessaires.",
  p5: "Tant notre philosophie d'entreprise que notre orientation éthique impliquent que NetBasis International se concentre stratégiquement sur un nombre limité de partenaires fabricants compétents qui ne sont pas en concurrence au sein de l'industrie. Car nous donnons la préférence au développement commun et à la collaboration synergétique au sein du groupe par rapport à une concurrence improductive.",
  p6: "Tout cela offre de la sécurité à chaque nouveau partenaire et fait partie du package que nous vous offrons, si vous décidez de travailler avec nous.",
  footerClaim: "NetBasis International - drive to excellence with excellent drivers !",
};

export const aboutCards = {
  management_title: "Management",
  management_desc:
    "Christof Günther a fondé NetBasis International au début de 2008 et en est le propriétaire. Fort de plus de 30 ans d'expérience internationale dans le secteur des TIC, il aide les fabricants étrangers à développer de nouveaux marchés avec leurs produits.",
  core_values_title: "Valeurs fondamentales",
  core_values_desc:
    "Respect. Loyauté. Professionnalisme. Persévérance. Confiance. Ce sont les valeurs fondamentales auxquelles NetBasis International s'est engagé et qui nous guident dans notre travail quotidien.",
  mission_vision_title: "Mission/Vision",
  mission_vision_desc:
    "Oui, ce sont toujours les résultats qui comptent au final. Mais ce qui est décisif sur le chemin, ce sont toujours les personnes ! NetBasis International vous permet de démarrer facilement votre activité sur de nouveaux marchés.",
  read_more: "En savoir plus",
};

export const aboutSubPages = {
  management: {
    title: "Direction",
    heroLine1: "Propulsé par l'expertise !",
    heroLine2: "",
    heroAlt: "Une main choisit un profil mis en avant pour un management TIC compétent sur le marché DACH.",
    p1_founded: "a fondé ",
    p1_owner: "début 2008 et en est le propriétaire.",
    p1: "Christof Günther a fondé NetBasis International début 2008 et en est le propriétaire.",
    p2: "Fort de plus de 30 ans d'expérience internationale dans le secteur des TIC, il aide les fabricants étrangers à développer de nouveaux marchés avec leurs produits. Son expertise se concentre sur tous les domaines du « Business Development ». Il élabore pour et avec ses partenaires commerciaux des concepts globaux d'entrée sur le marché et les accompagne dans la mise en œuvre et le pilotage de l'ensemble de leurs projets.",
    p3: "Il propose également aux entreprises intéressées ses connaissances du marché et son expertise sectorielle via des missions de conseil ou par des formations et du coaching.",
    p4: "Auparavant, M. Günther a occupé pendant de nombreuses années des postes à responsabilité (directeur de filiale, directeur commercial, directeur export, etc.) au sein de PME du secteur des télécommunications et de l'informatique opérant en Europe et/ou dans le monde entier.",
  },
  core_values: {
    title: "Valeurs fondamentales",
    heroLine1: "Avec des valeurs",
    heroLine2: "vers le succès !",
    heroAlt: "Une main ouverte porte des lignes numériques, symbole de confiance et de valeurs chez NetBasis.",
    p1: "Respect. Loyauté. Professionnalisme. Persévérance. Confiance.",
    p2: "Ce sont les valeurs fondamentales auxquelles NetBasis International s'est engagé et qui nous guident dans notre travail quotidien. Elles nous accompagnent dans notre dévouement envers nos partenaires commerciaux et nous guident dans la manière dont nous accomplissons nos missions.",
    p3: "Nous nous faisons un devoir de prouver aux nouveaux partenaires qu'ils ont fait le bon choix avec nous, et de démontrer sans cesse à nos partenaires existants, dans le cadre de nouveaux projets, qu'ils sont entre de bonnes mains avec nous.",
    p4: "Votre succès est notre engagement.",
  },
  mission_vision: {
    title: "Mission/Vision",
    heroLine1: "En équipe",
    heroLine2: "vers le succès !",
    heroAlt: "Des membres d'équipe superposent leurs mains pour une entrée commune sur le marché DACH.",
    p1: "Oui, ce sont toujours les résultats qui comptent au final. Mais ce qui est décisif sur le chemin, ce sont toujours les personnes !",
    p2: "NetBasis International vous permet de démarrer facilement votre activité sur de nouveaux marchés et d'obtenir très rapidement des résultats (pas seulement les premiers). Avec un bon produit ou une bonne solution, nous vous permettons de mettre en œuvre votre stratégie sans délai et avec succès. Nous vous aidons à être agile et compétitif.",
    p3: "Cependant, une activité réussie ne peut pas et ne pourra jamais reposer uniquement sur les produits ou les solutions. Les produits et les solutions ne se vendent pas tout seuls. D'excellents produits ou solutions à eux seuls n'apporteront ni résultats ni succès.",
    p4: "Les résultats et le succès, surtout à long terme, commencent toujours avec des personnes et ont toujours besoin de personnes. Ce sont toujours des personnes qui travaillent ensemble sur des stratégies et des objectifs commerciaux individuels et qui développent l'approche la mieux adaptée aux exigences, aux plans et aux objectifs. Nous croyons en cette approche centrée sur l'humain et sommes convaincus que c'est précisément cela qui fait la différence dans la vie des affaires.",
    p5: "C'est pourquoi une collaboration bonne et intensive est notre voie centrale pour faire des affaires. Nos experts s'associent à vos collaborateurs pour former une équipe solide et soudée, une équipe de « drivers » qui fera très certainement de votre projet d'entrée sur le marché un succès.",
  },
};

export const experiencePage = {
  title: "Expérience",
  heroClaimLine1: "Expérience & Expertise",
  heroClaimLine2: "... la base de votre succès !",
  benefits_title: "Ce que vous pourrez bientôt découvrir ici",
  benefit_0: "Aperçu des projets et entrées sur le marché réussis",
  benefit_1: "Témoignages clients et expériences de partenariat",
  benefit_2: "Aperçus détaillés des connaissances sectorielles et des marchés",
  benefit_3: "Chronologie et jalons de notre histoire d'entreprise",
  claim: "NetBasis International - drive to excellence with excellent drivers !",
};

export const contactPage = {
  hero: {
    title: "Nous nous réjouissons",
    subtitle: "de votre message !",
    heroAlt: "Deux mains présentent une carte de visite vierge pour contacter NetBasis à Düsseldorf.",
  },
  details: {
    title: "Coordonnées",
    company: "NetBasis International",
    address_line1: "Heinrichstraße 45",
    address_line2: "40239 Düsseldorf",
    address_country: "Allemagne",
    tel_label: "Téléphone :",
    tel_number: "+49 (0) 211 / 544 193 80",
    fax_label: "Fax :",
    fax_number: "+49 211 54419379",
    email_label: "Email :",
    email_address: "contact@net-basis.com",
  },
  form: {
    title: "N'hésitez pas à nous contacter",
    name: "Prénom et nom",
    name_placeholder: "Votre nom",
    company: "Entreprise",
    company_placeholder: "Votre entreprise",
    email: "Adresse e-mail",
    email_placeholder: "votre@email.fr",
    phone: "Numéro de téléphone",
    phone_placeholder: "+49 (0) ...",
    message: "Votre message",
    message_placeholder: "Votre message pour nous...",
    dsgvo_text: "J'accepte que les données de mon formulaire de contact soient collectées et traitées pour répondre à ma demande. Les données seront supprimées après le traitement de votre demande. Vous pouvez révoquer votre consentement pour l'avenir à tout moment en envoyant un e-mail à contact@net-basis.com. Des informations détaillées sur le traitement des données utilisateur sont disponibles dans notre politique de confidentialité.",
    submit: "envoyer",
    success_title: "Merci !",
    success_message: "Votre message a été envoyé avec succès. Nous vous répondrons dans les plus brefs délais.",
    error_default: "Une erreur s'est produite. Veuillez réessayer plus tard.",
    spam_question: "Question de sécurité : Combien font",
    spam_error: "Veuillez répondre à la question de sécurité.",
    spam_wrong: "La réponse est incorrecte. Veuillez réessayer.",
  },
  map: {
    title: "Notre emplacement",
    preview_title: "Google Maps est désactivé",
    preview_text: "Lorsque vous activez Google Maps, votre adresse IP est transmise aux serveurs de Google aux États-Unis. Vous trouverez des détails dans notre politique de confidentialité.",
    activate_button: "Activer le contenu",
  },
};

export const cookie_banner = {
  text: "Ce site utilise exclusivement des cookies techniquement nécessaires. Aucun cookie de suivi ou d'analyse n'est utilisé. Un cookie enregistre votre préférence pour Google Maps, un autre sert à la protection contre les bots de Cloudflare.",
  privacy_link: "En savoir plus dans notre politique de confidentialité.",
  button: "J'ai compris",
};

export const legalPage = {
  heroAlt: "Un doigt touche des § connectés pour les mentions légales et la protection des données NetBasis.",
};

export const imprintPage = {
  title: "Mentions légales",
  left_title: "Mentions légales",
  provider_title: "Mentions selon le § 5 DDG",
  provider_text: "Christof Günther\nNetBasis International\nHeinrichstraße 45\n40239 Düsseldorf\nAllemagne",
  contact_title: "Contact",
  phone_label: "Téléphone :",
  phone: "+49 (0) 211 / 544 193 80",
  email_label: "Email :",
  email: "contact@net-basis.com",
  web_label: "Internet :",
  web: "net-basis.net",
  vat_title: "Numéro d'identification TVA",
  vat_text: "Numéro d'identification de la taxe sur la valeur ajoutée conformément au § 27 a de la loi sur la TVA :\nDE 258 486 954",
  insurance_title: "Assurance RC Pro",
  insurance_text: "Nom et siège social de la compagnie :\nHiscox AG agissant pour le compte de Hiscox Insurance Company Ltd.\nSuccursale pour l'Allemagne, Arnulfstraße 31, 80636 Munich\nCouverture: Mondiale",
  right_title: "Avertissement légal",
  disclaimer_content_title: "Responsabilité du contenu",
  disclaimer_content_text: "Le contenu de notre site web a été élaboré avec le plus grand soin. Cependant, nous ne pouvons pas garantir l'exactitude, l'exhaustivité et l'actualité du contenu. En tant que fournisseur de services, nous sommes responsables de notre propre contenu sur ces pages conformément aux lois générales. Nous ne sommes toutefois pas tenus de surveiller les informations de tiers transmises ou stockées, ni de rechercher des circonstances indiquant une activité illégale. Les obligations de supprimer ou de bloquer l'utilisation d'informations en vertu des lois générales restent inchangées. Toutefois, la responsabilité à cet égard n'est possible qu'à partir du moment où nous avons connaissance d'une violation spécifique. Dès que nous avons connaissance de violations légales correspondantes, nous supprimerons immédiatement ce contenu.",
  disclaimer_links_title: "Responsabilité des liens",
  disclaimer_links_text: "Notre offre contient des liens vers des sites web externes de tiers sur le contenu desquels nous n'avons aucune influence. Par conséquent, nous ne pouvons assumer aucune responsabilité pour ces contenus externes. Le fournisseur ou l'exploitant respectif des pages liées est toujours responsable du contenu des pages liées. Les pages liées ont été vérifiées au moment de la création du lien pour d'éventuelles violations légales. Aucun contenu illégal n'était reconnaissable au moment de la création du lien. Cependant, un contrôle permanent du contenu des pages liées n'est pas raisonnable sans indices concrets d'une violation de la loi. Dès que nous avons connaissance de violations légales, nous supprimerons immédiatement ces liens.",
  disclaimer_copyright_title: "Droit d'auteur",
  disclaimer_copyright_text: "Le contenu et les œuvres créées ou utilisées par nous sur ces pages sont soumis au droit d'auteur allemand. La reproduction, le traitement, la distribution et toute forme d'exploitation en dehors des limites du droit d'auteur nécessitent notre consentement. Les téléchargements et copies de ce site ne sont autorisés que pour un usage privé et non commercial. Dans la mesure où le contenu de notre site n'a pas été créé par nous, les droits d'auteur des tiers sont respectés. En particulier, le contenu de tiers est identifié comme tel. Si vous deviez néanmoins avoir connaissance d'une violation du droit d'auteur, nous vous prions de nous en informer. Dès que nous avons connaissance de violations légales, nous supprimerons immédiatement ce contenu.",
  image_credits_title: "Crédits images",
  image_credits_intro: "Les images Fotolia/Adobe Stock utilisées sur ce site web ont été correctement licenciées. Veuillez consulter l'aperçu suivant pour les mentions de copyright détaillées :",
  image_credits_placeholder: "Espace réservé pour les crédits images (liste Fotolia/Adobe Stock)",
};

export const buttonizer = {
  trigger_label: "Contact",
  phone_label: "Appeler",
  email_label: "Email",
  email_address: "contact@net-basis.com",
  whatsapp_label: "WhatsApp",
  whatsapp_link: "https://wa.me/4915126386361",
  telegram_label: "Telegram",
  telegram_link: "https://t.me/ChriGue1",
  signal_label: "Signal",
  signal_link: "https://signal.me/#p/+4915126386361",
  messenger_label: "Messenger",
  messenger_link: "https://m.me/ChriGue1",
  phone_number: "+4921154419380",
  phone_display: "+49 (0) 211 / 544 193 80",
};

export const notFound = {
  title: "Cette page n'a pas encore été générée",
  message: "Dites-nous en plus sur cette page pour que nous puissions la générer pour vous.",
};